import React from 'react';
import BlogPosts from '../containers/BlogPosts.jsx';

export default (props) => (
  <BlogPosts {...props} />
);
